import {call, takeLatest, all, put} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import {getRoute} from 'Services/I18n/Utils'
import {AppRoute} from 'Services/I18n/Constants'

import API from 'Services/API'
import * as type from 'Store/types'
import {ContactUsType, ActionType} from 'Interfaces'

function* contactUs(action: ActionType<ContactUsType>) {
  const {response, error} = yield call(API.post, `/public/contact-us`, {
    ...action.payload,
  })
  if (response) {
    yield put({
      type: type.homepageHelpFaq.contactUs.send.succeeded,
    })
    yield put(push(getRoute(AppRoute.Profile)))
  } else {
    yield put({
      type: type.homepageHelpFaq.contactUs.send.failed,
      payload: error,
    })
  }
}

export default function* HomepageHelpFaqSaga(): Generator {
  yield all([
    takeLatest(type.homepageHelpFaq.contactUs.send.requested, contactUs),
  ])
}
